import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xd9mfkt5p: FaireProductEntity = {
  token: "p_4xd9mfkt5p",
  type: "product",
  name: "Foodie Gourmet - Belgian -White Chocolate Melting Wafers 29%",
  brandToken: "b_bzxg32q5dk",
  brandName: "Alta Gama Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/24546a4475a06f08238e03cfd899f40a31e0b099cb599395cce73b7c1f82bdcf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c9d85dc1d4225c3402dfd857f50ec05842d68bc021f612d3ba3cf20fb90a0f2.png",
    "https://cdn.faire.com/fastly/cdc8bb2a861895d33a34f8341a84f7ff512f0846ebea9209f2dbaca896b72a1c.jpeg",
    "https://cdn.faire.com/fastly/39dc88f7e5833dbc602300a1d2bf43a544863f50b575787813a851f1188716d0.png",
  ],
  priceDollars: 7.21,
  description:
    "Elevate your culinary creations with the creamy luxury of Foodie Gourmet White Chocolate Melting Wafers. Crafted in Belgium with 29% premium cocoa butter and the finest milk, these melting wafers offer a velvety texture and rich flavor that enhances both sweet and savory recipes. Whether you’re baking, dipping, or drizzling, these high-quality wafers are the perfect choice for a gourmet touch. 8.8oz\n\nbaking, cookies, cakes, cocao, Belgian chocolate melting wafers",
  tags: [],
  msrpDollars: 14.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:36.204Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
